import { render, staticRenderFns } from "./RegisterFunds.vue?vue&type=template&id=08aa1eee"
import script from "./RegisterFunds.vue?vue&type=script&lang=js"
export * from "./RegisterFunds.vue?vue&type=script&lang=js"
import style0 from "./RegisterFunds.vue?vue&type=style&index=0&id=08aa1eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports